export enum ETranslate {
	FlightNumber = '<flightNumber>',
}
